export default __webpack_public_path__ + "static/media/calendar.079daad2.png";